import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as styles from "/src/components/About/AboutTeam.module.css";
import { graphql, useStaticQuery } from "gatsby";
import { v4 as uuidv4 } from "uuid";

const AboutTeam = () => {
  const data = useStaticQuery(query);
  const staff = data.allContentfulStaff.nodes;
  return (
    <div className={styles.aboutTeam}>
      {staff.map((entry) => {
        const imagePath = getImage(entry.image.gatsbyImageData);
        return (
          <div className={styles.aboutTeamContainer} key={uuidv4()}>
            <div className={styles.employee}>
              <div className={styles.aboutTeamPhoto}>
                <GatsbyImage image={imagePath} alt={entry.position} />
              </div>
              <h4>{entry.name}</h4>
              <h5>{entry.position}</h5>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const query = graphql`
  {
    allContentfulStaff {
      nodes {
        name
        position
        image {
          gatsbyImageData(placeholder: TRACED_SVG, layout: CONSTRAINED)
        }
      }
    }
  }
`;

export default AboutTeam;
